var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"19.5","stroke":"#EEEEEE","strokeOpacity":"0.5","key":0}),React.createElement("path",{"d":"M18.6643 29H21.8375V20.7875H24.491L24.8917 17.5925H21.8375V15.545C21.8375 14.6225 22.0866 13.9925 23.3646 13.9925H25V11.1237C24.7184 11.09 23.7545 11 22.6282 11C20.2671 11 18.6643 12.4963 18.6643 15.23V17.5925H16V20.7875H18.6643V29Z","fill":"#EEEEEE","key":1})]);
}

Facebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
